export default {
	account: () => import('./account.vue'),
	accountStatus: () => import('./accountStatus.vue'),
	articleAssistant: () => import('./articleAssistant.vue'),
	columns: () => import('./columns.vue'),
	contentandaction: () => import('./contentandaction.vue'),
	custInfo: () => import('./custInfo.vue'),
	transTextFormat: () => import('./transTextFormat.vue'),
	iconbutton: () => import('./icon-button.vue'),
	inquirylist: () => import('./inquirylist.vue'),
	inquiryPhoto: () => import('./inquiryPhoto.vue'),
	mapping: () => import('./mapping.vue'),
	orderBtn: () => import('./orderBtn.vue'),
	percentage: () => import('./percentage.vue'),
	photo: () => import('./photo.vue'),
	platform: () => import('./platform.vue'),
	preview: () => import('./preview.vue'),
	seoBoard: () => import('./seoBoard.vue'),
	taskComplete: () => import('./taskComplete.vue'),
	thumbnail: () => import('./thumbnail.vue'),
	tweetStatus: () => import('./tweetStatus.vue'),
	updialog: () => import('./upDialog.vue'),
	vhtml: () => import('./vhtml.vue'),
	popoverView: () => import('./popoverView.vue'),
	listSwitch: () => import('./listSwitch.vue'),
	checkbox: () => import('./checkbox.vue'),
	inputNumber: () => import('./inputNumber.vue'),
	multiseriate: () => import('./multiseriate.vue'),
	tooltip: () => import('./tooltip.vue'),
	textStatus: () => import('./textStatus.vue'),
	multiRowPopover: () => import('./multi-row-popover.vue'),
	shadowDom: () => import('./shadowDom.vue'),
	iconPopover: () => import('./iconPopover.vue'),
	skyInputBtn: () => import('./skyInputBtn.vue'),
	skyInput: () => import('./skyInput.vue'),
	serviceSingleLabel: () => import('./serviceSingleLabel.vue'), // 服务单标签
	editInput: () => import('./edit-input.vue'), // 带编辑图标的输入框
	inputBox: () => import('./inputBox.vue'), // 输入框
	inputNumBox: () => import('./inputNumBox.vue'), // 数字输入框
	selectChange: () => import('./selectChange.vue'), // 选择器表单项
	arrayMultiLineShow: () => import('./arrayMultiLineShow.vue'), // 适用于数组多行展示，且每项数据后有操作图标
};
